module.exports = __webpack_public_path__ + "img/learn_balloon2.f705cefa.svg";